module.exports = __webpack_public_path__ + "img/coo_order.a24cd43a.png";